import { cva } from 'class-variance-authority';

const buttonVariants = cva(
  'flex rounded-100 items-center justify-center w-fit h-fit font-medium transition-all outline-fill-accent-primary outline-offset-2 focus-visible:outline-2 focus-visible:outline',
  {
    variants: {
      variant: {
        primary:
          'bg-fill-accent-primary text-content-inverse hover:bg-fill-accent-primary-hover active:bg-fill-accent-primary-selected',
        secondary:
          'border border-border-neutral text-content-accent hover:bg-fill-neutral-hover active:bg-fill-neutral-selected hover:border-border-neutral-hover active:border-border-neutral-selected',
        tertiary: 'text-content-accent hover:bg-fill-neutral-hover active:bg-fill-neutral-selected',
      },
      size: {
        small: 'py-100 px-150 gap-050',
        medium: 'py-125 px-200 gap-050',
        large: 'py-175 px-250 gap-100',
      },
      disabled: {
        true: 'cursor-not-allowed opacity-048',
        false: 'cursor-pointer',
      },
      critical: { true: 'font-medium' },
    },
    compoundVariants: [
      {
        variant: 'primary',
        disabled: true,
        className: 'hover:bg-fill-accent-primary active:bg-fill-accent-primary',
      },
      {
        variant: ['secondary', 'tertiary'],
        disabled: true,
        className:
          'hover:bg-transparent active:bg-transparent hover:border-border-neutral active:border-border-neutral',
      },
      {
        variant: 'primary',
        critical: true,
        disabled: false,
        className:
          'bg-fill-critical text-content-inverse hover:bg-fill-critical-hover active:bg-fill-critical-selected',
      },
      {
        variant: 'secondary',
        critical: true,
        disabled: false,
        className:
          'text-content-critical border border-border-critical hover:bg-fill-neutral-hover active:bg-fill-neutral-selected hover:border-border-critical active:border-border-critical',
      },
      {
        variant: 'tertiary',
        critical: true,
        disabled: false,
        className:
          'text-content-critical hover:bg-fill-neutral-hover active:bg-fill-neutral-selected',
      },
      {
        variant: 'primary',
        critical: true,
        disabled: true,
        className:
          'bg-fill-critical text-content-inverse hover:bg-fill-critical active:bg-fill-critical',
      },
      {
        variant: 'secondary',
        critical: true,
        disabled: true,
        className:
          'text-content-critical border border-border-critical hover:border-border-critical active:border-border-critical',
      },
      {
        variant: 'tertiary',
        critical: true,
        disabled: true,
        className: 'text-content-critical',
      },
    ],
    defaultVariants: {
      variant: 'primary',
      size: 'medium',
      disabled: false,
      critical: false,
    },
  },
);

export { buttonVariants };
